import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {Injectable} from '@angular/core';
import {mergeMap} from 'rxjs/operators';
import { CurrentUserActions } from '../../actions/user/current-user.actions';


@Injectable()
export class InitEffects {

  
  dispatchMultiAction$ = createEffect(() => this.actions$.pipe(
    ofType(ROOT_EFFECTS_INIT),
    mergeMap(_ =>
      [
        CurrentUserActions.loadCurrentUserFromStorage(),
      ])
  ));


  constructor(private actions$: Actions) {
  }
}
